<template>
  <div class="modal fade fdemodal" id="fdemodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title"><b>Fotodokumentation erstellen</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
        </div>
        <div class="modal-body">
          <div class="option-container">
            <input type="radio"  name="radio" id="option1" v-model="doc.reporttype" value="0">
            <label for="option1" class="option__button">
              <h4>Tagesdokumentation</h4>
              <p>Erstellen Sie eine Fotodokumentation die alle Fotos eines bestimmten Tages beinhaltet.</p>
            </label>

            <input type="radio" name="radio" id="option2" v-model="doc.reporttype" value="1">
            <label for="option2" class="option__button">
              <h4>Individuelle Fotodokumentation</h4>
              <p>Erstellen Sie eine Fotodokumentation in der Sie die beinhalteten Fotos vorab auswählen. </p>
            </label>
          </div>

        </div>
        <div class="modal-footer border-0">
          <div class="dokubtns"> <span class="btninner">
            <button type="button" class="btn btn-red" data-dismiss="modal">Abbrechen</button>
            <button type="button" class="btn btn-blue" data-dismiss="modal" @click="showDetailsTag">
              Neu erstellen
            </button>
          </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  data(){
    return {}
  },
  computed : {
    ...mapState({
      doc: state =>  state.photoDocumentation.newDocumentDetails,
    })
  },
  mounted () {
      this.doc.reporttype = "0"
  },
  methods : {
    showDetailsTag () {
      if (this.doc.reporttype == '1'){
        this.$store.commit("setSelectedImages", [] );
      }
      this.$router.push({name: 'photoDocumentCreate',params: { id: this.$route.params.id }})
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/DocumentTypeModal.vue